export function podeVerLogsProjeto({ isAuditor, userId, projeto, pcm } = {}) {
  if (isAuditor) return true

  const id = Number(userId)
  if (!Number.isFinite(id) || id <= 0) return false

  return Number(projeto?.gerente_id) === id
    || Number(projeto?.assessor_id) === id
    || Number(pcm?.gerentePCM_id) === id
}
